import React, { Fragment, useState, useEffect } from 'react';
import SingleSelect from '../../common/Forms/SingleSelect';
import MultiSelect from '../../common/Forms/MultiSelect';

const AudienceSelection = ({ initialAudience, initialTargets = [], options, targetOptions }) => {
  const [audience, setAudience] = useState(initialAudience);
  const [targets, setTargets] = useState(initialTargets);

  const handleChange = (option) => {
    setAudience(option);
  };

  const handleMultiChange = (option) => {
    setTargets(option);
  };

  return (
    <Fragment>
      <div style={ { width: '100%' } }>
        <input name="scheduled_job[audience]"
               value={audience && audience.value}
               hidden/>
        <SingleSelect
          handleChange={handleChange}
          options={options}
          selectedValue={audience}
          placeholderText="Select audience"
        />
      </div>

      <br />

      {audience && audience.value === 'School' && (
        <div style={ { width: '100%' } }>
          <input name="scheduled_job[school_targets]"
                 value={targets && targets.map((target) => target.value)}
                 hidden/>
          <MultiSelect
            handleChange={handleMultiChange}
            options={targetOptions}
            selectedValues={targets}
            placeholderText="Select School Audience"
          />
        </div>
      )}
    </Fragment>
  )
}

export default AudienceSelection;
